import Layout from '@/views/layout/Layout'
const unionRouter = {
    path: '/userCenter',
    name: 'userCenter',
    component: Layout,
    redirect: 'noRedirect',
    children: [
        // 联盟申请路由
        {
            path: 'logunionSystem',
            name: 'logunionSystem',
            component: () => import('@/views/userCenter/union/logunionSystem'),
        },
        // 联盟申请信息路由
        {
            path: 'logunionInfo',
            name: 'logunionInfo',
            component: () => import('@/views/userCenter/union/logunionInfo'),
        },
        // 联盟申请支付路由
        {
            path: 'logunionPay',
            name: 'logunionPay',
            component: () => import('@/views/userCenter/union/logunionPay'),
        },
        // 联盟功能设置路由
        {
            path: 'logunionSet',
            name: 'logunionSet',
            component: () => import('@/views/userCenter/union/logunionSet'),
        },
        // 联盟订单列表路由
        {
            path: 'logorderUnion',
            name: 'logorderUnion',
            component: () => import('@/views/userCenter/union/logorderUnion'),
        },
        // 联盟供应产品发布路由
        {
            path: 'logunionSupplyAdd',
            name: 'logunionSupplyAdd',
            component: () => import('@/views/userCenter/union/logunionSupplyAdd'),
        },
        // 联盟供应产品列表路由
        {
            path: 'logunionSupplyList',
            name: 'logunionSupplyList',
            component: () => import('@/views/userCenter/union/logunionSupplyList'),
        },
    ]
}
export default unionRouter


// WEBPACK FOOTER //
// ./src/router/modules/union.js